<template>
    <b-skeleton-img
        v-if="busy"
        height="300px"
    />
    <apexchart
        v-else
        class="apex-charts"
        height="300"
        type="bar"
        :series="series"
        :options="options"
    />
</template>

<script>
  export default {
    name: "ColumnChart",
    props: {
        hideLegend: {
            required: false,
            type: Boolean,
        },
        seriesProp: {
            required: true,
            type: Array,
        },
        categoriesSeriesProp: {
            required: false,
            type: Array,
            default: () => [],
        },
        colorsProp: {
            required: false,
            type: Array,
            default: () => {
                return ['#2E7FEB', '#F3D63F', '#64BB77', '#FD4084', '#F4AC57', '#C51FE0', '#404249']
            }
        },
        busy: {
            required: false,
            type: Boolean,
        },
        yaxisConfig: {
            required: false,
            type: Object,
            default: () => null,
        },
        dataLabelsSuffix: {
            required: false,
            type: String,
            default: '',
        },
        /** 'top' = above bar, 'center' = inside bar */
        dataLabelsPosition: {
            required: false,
            type: String,
            default: 'top',
            validator: (v) => ['top', 'center'].includes(v),
        },
    },
    data() {
      return {}
    },
    computed: {
        series() {
            return this.seriesProp
        },
        options() {
            const options = {
                chart: {
                    height: 300,
                    type: 'bar',
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: true,
                    position: this.dataLabelsPosition,
                    ...(this.dataLabelsSuffix ? {
                        formatter: (value) => (value != null ? String(value) : '') + this.dataLabelsSuffix,
                    } : {}),
                    background: {
                        borderRadius: 5,
                        borderColor: 'transparent',
                        opacity: 1,
                    }
                },
                plotOptions: {
                    bar: {
                        distributed: this.hideLegend,
                        dataLabels: {
                            position: this.dataLabelsPosition,
                        },
                    }
                },
                stroke: {
                    curve: 'straight'
                },
                grid: {
                    row: {
                        colors: ['#f9f9f9', 'transparent'],
                        opacity: 0.5
                    },
                },
                legend: {
                    show: !this.hideLegend,
                },
                xaxis: {
                    categories: this.categoriesSeriesProp && this.categoriesSeriesProp.length > 0 ? this.categoriesSeriesProp : [''],
                    labels: {
                        show: this.categoriesSeriesProp && this.categoriesSeriesProp.length > 0,
                    },
                },
                colors: this.colorsProp,
            }

            if (this.yaxisConfig) {
                options.yaxis = this.yaxisConfig
            }

            return options
        }
    }

  }
</script>
